import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-208c3ad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "MiROS | SignUp", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Create New Account", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-box center"
}
const _hoisted_4 = { class: "center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "body-text" }, "User Name:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "body-text" }, "Email:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "body-text" }, "Password:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "body-text" }, "Confirm Password:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_10 = { class: "sub-div" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "body-text subtitle" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Already have an account? Click here to sign in: ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("html", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("body", null, [
      (_ctx.errorVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorText), 1))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
            }, null, 512), [
              [_vModelText, _ctx.username]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_6,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_7,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              type: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordConfirm) = $event))
            }, null, 512), [
              [_vModelText, _ctx.passwordConfirm]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_9,
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              class: "rectangle-button float-right",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.signUp(_ctx.username, _ctx.email, _ctx.password, _ctx.passwordConfirm)))
            }, " Sign up ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_router_link, {
          class: "subtitle",
          to: "/login"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign In")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}